import { makeStyles } from '@fluentui/react-components';
import { isMobile } from 'react-device-detect';

import { customTokens } from 'src/utils/theme';

export const useFooterStyles = makeStyles({
  footerContainer: {
    display: 'flex',
    flexDirection: isMobile ? 'column' : 'row',
    justifyContent: 'space-between',
    alignItems: isMobile ? 'center' : undefined,
    flexWrap: 'wrap',
    gap: customTokens.spacingHorizontalL,
    padding: isMobile ? `${customTokens.spacingVerticalM}` : `${customTokens.spacingVerticalL}`,
  },
  firstContentContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  commonTextStyles: {
    fontSize: isMobile ? customTokens.fontSizeBase100 : customTokens.fontSizeBase300,
  },
  webMdLogoImg: {
    height: '33px',
  },
  logoContainer: {
    display: 'flex',
    marginBottom: customTokens.spacingVerticalL,
    flexDirection: isMobile ? 'column' : 'row',
    alignItems: isMobile ? 'flex-start' : 'flex-end',
  },
  contactContainer: {
    marginTop: isMobile ? customTokens.spacingVerticalS : undefined,
    marginLeft: isMobile ? undefined : customTokens.spacingHorizontalXXL,
    display: 'flex',
    alignItems: 'flex-end',
    columnGap: customTokens.spacingHorizontalL,
    lineHeight: customTokens.lineHeightBase100,
  },
  copyrightContainer: {
    display: 'flex',
    columnGap: customTokens.spacingHorizontalSNudge,
  },
  secondContentContainer: {
    display: 'flex',
  },
  accreditedImgWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  accreditedImg: {
    width: '64px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  accreditedImgLabel: {
    fontSize: customTokens.fontSizeBase100,
    fontWeight: customTokens.fontWeightMedium,
    lineHeight: customTokens.lineHeightBase100,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: customTokens.spacingVerticalXS,
  },
  accreditedImgContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    columnGap: customTokens.spacingHorizontalM,
  },
  fontSizeXS: {
    fontSize: customTokens.fontSizeBase50,
  },
  redColor: {
    color: '#E43B28',
  },
});
